'use strict';
import {Currencies} from "./endpoints/Currencies.js";
import countries from '../json/countries.json';

export class Helper {
	constructor() {
		this.admin_ajax = admin_ajax[0];
	}

	static getSectionSetting(settings, setting_name, setting_section, sub_section = '', key = '')  {
		if(!(settings.hasOwnProperty(setting_name) && settings[setting_name])) {
			return '';
		}


		if(!settings[setting_name].hasOwnProperty(setting_section)) {
			return '';
		}

		let section_settings = settings[setting_name][setting_section];

		if(sub_section && section_settings.hasOwnProperty(sub_section)) {
			section_settings = section_settings[sub_section];
		} else if (sub_section) {
			return '';
		}

		if(!key) {
			return section_settings;
		}

		if(section_settings.hasOwnProperty(key)) {
			return section_settings[key];
		}

		return '';
	}

	clearEmptyInputsOnSubmit( tabClass ) {
		document.addEventListener( 'click', ( event ) => {
			const optionsForm = document.querySelector(
				'form[action="options.php"]'
			);
			if ( event.target.matches( '#submit' ) && optionsForm ) {
				event.preventDefault();

				document
					.querySelectorAll(
						`${ tabClass } input:not([type="hidden"]):not([type="search"])`
					)
					.forEach( ( input ) => {
						if ( ! input.value ) {
							const inputRow = input.closest(
								'.levcharity_input_wrapper'
							);
							inputRow.remove();
						}
					} );

				optionsForm.requestSubmit();
			}
		} );
	}

	makeCheckedActive( checkboxes ) {
		if ( ! checkboxes ) {
			return;
		}

		checkboxes.forEach( ( input ) => {
			if ( input.checked ) {
				const parent = input.closest( '.item_wrapper' );
				parent.classList.add( 'active' );
			}

			input.addEventListener( 'change', ( event ) => {
				const parent = event.target.closest( '.item_wrapper' );

				if ( event.target.checked ) {
					if ( ! parent.classList.contains( 'active' ) ) {
						parent.classList.add( 'active' );
					}
				}

				if ( ! event.target.checked ) {
					if ( parent.classList.contains( 'active' ) ) {
						parent.classList.remove( 'active' );
					}
				}
			} );
		} );
	}

	findObjectById = ( array, id ) => {
		for ( let i = 0; i < array?.length; i++ ) {
			if ( array[ i ].id === id ) {
				return i;
			}
		}
		return -1;
	};

	amendProductPrice = ( productArray, conversion ) => {
		productArray.forEach( ( product ) => {
			const regularPrice = product.dataset.price;
			product.querySelector( '.product_price' ).innerHTML = (
				Number( regularPrice ) * Number( conversion )
			).toLocaleString( 'en-US', {
				maximumFractionDigits: 0,
			} );
		} );
	};

	capitalizeEachWord(sentence) {
		return sentence.replace(/\b\w/g, (char) => char.toUpperCase());
	}

	async getCurrencySymbol(currency) {
		const allCurrencies = await new Currencies().fetchData();

		if (allCurrencies?.length === 0) {
			return;
		}

		const currencyItem = allCurrencies.find(item => item.ticker === currency);

		if (currencyItem) {
			return currencyItem.symbol;
		}
	}

	getProductByType( productType, onlyPublished = false) {
		return new Promise((resolve, reject) => {
			const siteUrl = this.admin_ajax;
			const params = `action=get_products_by_type&product_types=${productType}${onlyPublished ? '&only_published=true' : ''}`;
			const xhr = new XMLHttpRequest();

			xhr.open('POST', siteUrl, true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						const response = xhr.response ? JSON.parse(xhr.response) : false;
						if (response) {
							resolve(response.products);
						} else {
							reject([]);
						}
					} else {
						reject(`Error: ${xhr.status}`);
					}
				}
			};
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);
		});
	}

	getProductVariables( parentID, orderID = 0 ) {
		return new Promise((resolve, reject) => {
			const siteUrl = this.admin_ajax;
			const params = `action=get_products_variables&parent_id=${parentID}&order_id=${orderID}`;
			const xhr = new XMLHttpRequest();

			xhr.open('POST', siteUrl, true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						const response = xhr.response ? JSON.parse(xhr.response) : false;
						if (response) {
							resolve(response.data);
						} else {
							reject([]);
						}
					} else {
						reject(`Error: ${xhr.status}`);
					}
				}
			};
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);
		});
	}

	makeOptionsSelected(items = [], selected = []) {
		if (typeof selected === 'string'){
			try {
				let newSelected = JSON.parse(selected);

				if (typeof newSelected !== 'object') {
					selected = selected.split(',');
				} else {
					selected = newSelected;
				}
			} catch {
				selected = selected.split(',');
			}
		}



		if (items?.length > 0) {
			items.forEach((item) => {
				//this extra condition to prevent passing selected options
				if (item.selected === true) {
					delete item.selected;
				}
				if (selected.includes(item.value.toString())) {
					item.selected = true;
				}
			});
			return items
		}
		return items
	}

	getTeamsConnectedToCampaign(campaignId){
		return new Promise((resolve, reject) => {
			const siteUrl = this.admin_ajax;
			const params = `action=get_teams_connected_to_campaign&campaign_id=${campaignId}`;
			const xhr = new XMLHttpRequest();

			xhr.open('POST', siteUrl, true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						const response = xhr.response ? JSON.parse(xhr.response) : false;
						if (response) {
							resolve(response.teams);
						} else {
							reject([]);
						}
					} else {
						reject(`Error: ${xhr.status}`);
					}
				}
			};
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);
		});
	}

	getIndividualsConnectedToCampaign(campaignId){
		return new Promise((resolve, reject) => {
			const siteUrl = this.admin_ajax;
			const params = `action=get_individuals_connected_to_campaign&campaign_id=${campaignId}`;
			const xhr = new XMLHttpRequest();

			xhr.open('POST', siteUrl, true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						const response = xhr.response ? JSON.parse(xhr.response) : false;
						if (response) {
							resolve(response.members);
						} else {
							reject([]);
						}
					} else {
						reject(`Error: ${xhr.status}`);
					}
				}
			};
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);
		});
	}

	getTeamMembersConnectedToCampaign(teamId,campaignId){
		return new Promise((resolve, reject) => {
			const siteUrl = this.admin_ajax;
			const params = `action=get_team_members_connected_to_campaign&campaign_id=${campaignId}&team_id=${teamId}`;
			const xhr = new XMLHttpRequest();

			xhr.open('POST', siteUrl, true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						const response = xhr.response ? JSON.parse(xhr.response) : false;
						if (response) {
							resolve(response.members);
						} else {
							reject([]);
						}
					} else {
						reject(`Error: ${xhr.status}`);
					}
				}
			};
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);
		});
	}

	disableNumberInputScroll() {
		const numberInputs = document.querySelectorAll('input[type="number"]');
		numberInputs?.forEach((input) => {
			input.addEventListener('wheel', (event) => {
				event.preventDefault();
			});
		});
	}

	setTimezoneOffset() {
		// Get the user's timezone offset in minutes
		const timezoneOffset = new Date().getTimezoneOffset();
		document.cookie = "timezone_offset=" + timezoneOffset + "; path=/;";
	}

	async setUserCountryCode(){
		let country_code = '';
		let country = {};
		let timezone = '';
		if (!localStorage.getItem('levcharity_user_country_code')){
			timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

			if (!timezone) return;

			country = countries.find(c => c.timezones.includes(timezone)) || {};

			country_code = country?.code || 'US';

			localStorage.setItem('levcharity_user_country_code', country_code)
		}
	}

	static date(format, timestamp = null) {
		let date;
		if (timestamp) {
			date = new Date(timestamp * 1000);
		} else {
			date = new Date();
		}

		if (!format){
			return date.getTime();
		}

		const day = date.getDate(),
			month = date.getMonth() + 1,
			year = date.getFullYear(),
			hours = date.getHours(),
			minutes = date.getMinutes(),
			seconds = date.getSeconds(),
			milliseconds = date.getMilliseconds();

		const replacements = {
			'd': day < 10 ? '0' + day : day,
			'D': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()],
			'j': day,
			'l': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()],
			'N': date.getDay() == 0 ? 7 : date.getDay(),
			'S': ['st', 'nd', 'rd'][((day + '').substr(-1) > 3) ? 0 : ((day + '').substr(-1) - 1)],
			'w': date.getDay(),
			'z': Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 86400000),
			'W': Math.ceil((date - new Date(date.getFullYear(), 0, 1)) / 86400000 / 7),
			'F': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month - 1],
			'm': month < 10 ? '0' + month : month,
			'M': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month - 1],
			'n': month,
			't': new Date(year, month, 0).getDate(),
			'L': year % 4 == 0 && year % 100 != 0 || year % 400 == 0 ? 1 : 0,
			'Y': year,
			'y': ('' + year).slice(2),
			'a': hours < 12 ? 'am' : 'pm',
			'A': hours < 12 ? 'AM' : 'PM',
			'g': hours % 12 || 12,
			'G': hours,
			'h': (hours % 12 || 12) < 10 ? '0' + (hours % 12 || 12) : (hours % 12 || 12),
			'H': hours < 10 ? '0' + hours : hours,
			'i': minutes < 10 ? '0' + minutes : minutes,
			's': seconds < 10 ? '0' + seconds : seconds,
			'f': milliseconds,
			'ff': Array(3 - ('' + milliseconds).length).fill('0').join('') + milliseconds,
		};

		return format.replace(/(d|D|j|l|N|S|w|z|W|F|m|M|n|t|L|Y|y|a|A|g|G|h|H|i|s|f|ff)(?!.*\1)/g, function(match) {
			return replacements[match];
		});
	}

	static strtotime(timeString) {
		const phrases = {
			'-1 day': () => Date.now() - (24 * 60 * 60 * 1000),
			'-1 week': () => Date.now() - (7 * 24 * 60 * 60 * 1000),
			'-1 month': () => {
				const currentDate = new Date();
				currentDate.setMonth(currentDate.getMonth() - 1);
				return currentDate.getTime();
			},
			'-1 year': () => {
				const currentDate = new Date();
				currentDate.setFullYear(currentDate.getFullYear() - 1);
				return currentDate.getTime();
			},
			'now': () => Date.now(),
			'+1 day': () => Date.now() + (24 * 60 * 60 * 1000),
			'+1 week': () => Date.now() + (7 * 24 * 60 * 60 * 1000),
			'+1 month': () => {
				const currentDate = new Date();
				currentDate.setMonth(currentDate.getMonth() + 1);
				return currentDate.getTime();
			},
			'+1 year': () => {
				const currentDate = new Date();
				currentDate.setFullYear(currentDate.getFullYear() + 1);
				return currentDate.getTime();
			}
		};

		if (phrases[timeString]) {
			return Math.floor(phrases[timeString]() / 1000);
		}

		const timestamp = Date.parse(timeString);
		if (!isNaN(timestamp)) {
			return Math.floor(timestamp / 1000);
		}

		return NaN;
	}

	static timeDifference(date1, date2, format = false) {
		let timestamp1 = date1;
		let timestamp2 = date2;

		if (typeof timestamp1 !== 'number'){
			timestamp1 = this.strtotime(timestamp1)
		}
		if (typeof timestamp2 !== 'number'){
			timestamp2 = this.strtotime(timestamp2)
		}
		var differenceMs = Math.abs(timestamp2 - timestamp1);

		var years = Math.floor(differenceMs / (1000 * 60 * 60 * 24 * 365));
		var months = Math.floor(differenceMs / (1000 * 60 * 60 * 24 * 30.4375));
		var weeks = Math.floor(differenceMs / (1000 * 60 * 60 * 24 * 7));
		var days = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
		var hours = Math.floor((differenceMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((differenceMs % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((differenceMs % (1000 * 60)) / 1000);
		var milliseconds = differenceMs % 1000;

		const data = {
			years: years,
			months: months,
			weeks: weeks,
			days: days,
			hours: hours,
			minutes: minutes,
			seconds: seconds,
			milliseconds: milliseconds
		};

		if (format === 'full') {
			return `${years} Years, ${months} Months, ${weeks} Weeks, ${days} Days, ${hours} Hours, ${minutes} Minutes, ${seconds} Seconds, ${milliseconds} Milliseconds`
		} else if (format === 'full-short') {
			return `${years}y, ${months}mos, ${weeks}w, ${days}d, ${hours}h, ${minutes}m, ${seconds}s, ${milliseconds}ms`
		} else if (format === 'time') {
			return `${hours}h, ${minutes}m, ${seconds}s, ${milliseconds}ms`;
		}

		return data;
	}

	static async request(url, data = {}, options = {}, secure = false){
		const defaultOptions = {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			headers: {
				"Content-Type": 'application/x-www-form-urlencoded'
			},
		}

		options = {
			...defaultOptions,
			...options
		}

		const contentType = typeof options?.headers['Content-Type'] === 'string' ? options.headers['Content-Type'] : '';

		const formData = (data instanceof FormData) ? data : this.objectToFormData(data)

		const params = new URLSearchParams(formData);

		if (options?.method?.toLowerCase() === 'get') {
			let _url = new URL(url);

			for (const [key, value] of params.entries()) {
				_url.searchParams.set(key, value);
			}

			url = _url.toString();
		} else {
			options.body = contentType === 'application/x-www-form-urlencoded' ? params : formData;
		}
		return await new Promise(async (resolve, reject) => {
			await fetch(url, options)
				.then(async response => {
					let res = response;

					if (secure) {
						let blob = await response.blob().then(async (blob) => {
							try {
								res = JSON.parse(await blob.text());
							} catch (e) {
								res = await blob.text()
							}

							return blob;
						});
					} else {
						try {
							res = res.json()
						} catch (e) {
							res = res.text()
						}
					}

					return res;
				})
				.then(async response => {
					if (typeof response.success === 'undefined' || response.success) {
						await resolve(response)
					} else {
						await reject(response)
					}
				})
				.catch(async response => {
					await reject(response);
				})
		});
	}

	static objectToFormData(obj, formData = new FormData(), parentKey = '') {
		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				const propName = parentKey ? `${parentKey}[${key}]` : key;
				if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
					this.objectToFormData(obj[key], formData, propName);
				} else {
					formData.append(propName, obj[key]);
				}
			}
		}
		return formData;
	}

	static slugify(title) {
		var sanitizedTitle = title.replace(/[^\w\s]/gi, '-');

		// Replace multiple spaces with a single dash
		sanitizedTitle = sanitizedTitle.replace(/\s+/g, '-');

		// Trim leading and trailing spaces and dashes
		sanitizedTitle = sanitizedTitle.trim().replace(/^-+|-+$/g, '');

		return sanitizedTitle.toLowerCase();
	}

	static uniqueID(length) {
		if (!this?.set) {
			this.set = new Set();
		}
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz0123456789012345678901234567890123456789';

		let result = '';
		do {
			for (let i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * characters?.length));
			}
		} while (this.set.has(result)); // Check if the generated string is already in the set
		this.set.add(result); // Add the generated string to the set
		return result;
	}

	static getModuleName(module) {
		let moduleName = null;
		switch (module) {
			case '':
			case 'levcharity':
			case 'main':
				moduleName = 'levcharity';
				break;
			case 'campaigns':
			case 'campaign':
				moduleName = 'levcharity-campaigns'
				break;
			case 'crm':
				moduleName = 'levcharity-crm'
				break;
			case 'debugger':
				moduleName = 'levcharity-debugger'
				break;
			case 'donation-equipment':
			case 'equipments':
			case 'equipment':
				moduleName = 'levcharity-donation-equipment'
				break;
			case 'ecards':
			case 'e-cards':
			case 'e-card':
			case 'ecard':
				moduleName = 'levcharity-ecards'
				break;
			case 'events':
			case 'event':
				moduleName = 'levcharity-events'
				break;
			case 'gateways':
			case 'gateway':
				moduleName = 'levcharity-gateways'
				break;
			case 'gravityform-product':
			case 'gravity-product':
				moduleName = 'levcharity-gravityform-product'
				break;
			case 'matching-campaigns':
			case 'matching-campaign':
				moduleName = 'levcharity-matching-campaigns'
				break;
			case 'memberships':
			case 'membership':
				moduleName = 'levcharity-memberships'
				break;
			case 'offline':
				moduleName = 'levcharity-offline'
				break;
			case 'p2p-campaigns':
			case 'p2p-campaign':
			case 'p2p':
				moduleName = 'levcharity-p2p-campaigns'
				break;
			case 'salesforce':
			case 'sf':
				moduleName = 'levcharity-salesforce'
				break;
			case 'teams':
			case 'team':
				moduleName = 'levcharity-teams'
				break;
		}

		return moduleName;
	}

	static getModuleAssetsUrl(module = '') {
		const scriptJS = document.querySelector('script[id="levcharity_editor.js-js"], script[id="levcharity_front.js-js"]');
		const pluginsUrl = scriptJS.src.match(/^(.*?\/plugins)\//)[0] || '';
		let moduleName = this.getModuleName(module);

		if (moduleName && pluginsUrl) {
			return pluginsUrl + moduleName + '/assets';
		}

		return '';
	}

	static currencyNumberFormatter(number, currencySymbol, with_fractions = true, locale='en-US') {
		const options = {
			style: 'currency',
			currency: currencySymbol,
			minimumFractionDigits : 0,
			maximumFractionDigits : 0,
		};

		if (with_fractions) {
			options.minimumFractionDigits = 2;
			options.maximumFractionDigits = 2;
		}

		if (typeof Intl !== 'undefined') {
			return new Intl.NumberFormat(locale, options).format(number).replace(currencySymbol, currencySymbol + ' ');
		}

		return number;
	}
}
